import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Image, DollarSign, Clock, Palette, Package, FileText, Calculator, Shield, Sparkles } from 'lucide-react';
const features = [{
  icon: BookOpen,
  title: '40 ideias prontas e testadas',
  description: 'Divididas por estilo: rústico, romântico, minimalista, moderno, clássico e boho. Você escolhe o que combina com o seu casamento.'
}, {
  icon: Image,
  title: 'Fotos de referência de cada ideia',
  description: "Veja exatamente como fica pronto. Sem surpresas, sem 'achismos'. Você sabe o resultado antes de começar."
}, {
  icon: DollarSign,
  title: 'Lista de materiais com custo estimado',
  description: 'Saiba quanto vai gastar por unidade antes de comprar qualquer coisa. Planeje seu orçamento com precisão.'
}, {
  icon: Clock,
  title: 'Passo a passo simples e rápido',
  description: 'Sem técnicas complicadas. Sem ferramentas especiais. Apenas instruções claras que qualquer pessoa consegue seguir.'
}, {
  icon: Palette,
  title: 'Variações para diferentes temas',
  description: 'Adapte cada ideia para o seu tema específico. Cores, estilos e acabamentos que combinam com a sua festa.'
}, {
  icon: Sparkles,
  title: 'Truques do Efeito Boutique™',
  description: 'Os segredos usados em casamentos de luxo que você pode aplicar gastando centavos. Este é o diferencial.'
}];
export function FeaturesSection() {
  return <section className="py-24 bg-gradient-to-br from-gray-50 to-rose-50" data-id="element-40">
      <div className="max-w-7xl mx-auto px-6" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-42">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-43">
            O Que Você Vai Receber
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-44">
            Um sistema completo, passo a passo, para criar lembrancinhas que
            parecem caras gastando pouco
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-8" data-id="element-45">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05,
          duration: 0.5
        }} className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300" data-id="element-46">
              <div className="flex items-start gap-5" data-id="element-47">
                <div className="bg-gradient-to-br from-rose-100 to-pink-100 p-4 rounded-xl flex-shrink-0" data-id="element-48">
                  <feature.icon className="w-7 h-7 text-rose-600" data-id="element-49" />
                </div>
                <div data-id="element-50">
                  <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-51">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-52">
                    {feature.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6,
        duration: 0.6
      }} className="mt-16 bg-gradient-to-r from-rose-500 to-pink-600 p-10 rounded-3xl shadow-2xl text-white text-center" data-id="element-53">
          <h3 className="text-3xl font-bold mb-4" data-id="element-54">
            Tudo isso em um único guia completo
          </h3>
          <p className="text-xl opacity-95 max-w-2xl mx-auto" data-id="element-55">
            Você não precisa pesquisar mais nada. Não precisa ficar perdida no
            Pinterest. Tudo que você precisa está aqui, organizado e pronto para
            usar.
          </p>
        </motion.div>
      </div>
    </section>;
}